import { useEffect, useState } from 'react'
import { makeSideBarActive } from '../../utils/EllowUtils';
import SideMenu from '../sideMenu'
import * as CONSTANTS from "../../utils/CONSTANTS";
import Table from '../../components/table';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getListTimesheetDetails } from './services'
import Styles from "./styles.module.scss";
import ellowLogo from "../../assets/images/ellow-logo.svg";
import NotificationAlert from "../../components/notification";
import file_download from "../../assets/images/file_download.svg"
import { CSVLink, CSVDownload } from "react-csv";



const CandidateTimesheetDownload = () => {
    const location = useLocation();


    const { year, month, company_name, timeSheetSelectedRow }: any = location.state || ''

    const menu = makeSideBarActive(CONSTANTS.sideMenu, 4);
    const [timesheetData1, setTimesheetData1] = useState<any>()
    const [timesheetCount, setTimesheetCount] = useState<any>([])
    const [sort, setSort] = useState<any>([]);
    const [error, setError] = useState<boolean>(false);
    const [total, setTotal] = useState(0);
    const [notification, setNotification] = useState<boolean>(false)

        const headers = [
                { label: "Date", key: "submittedOn" },
                { label: "Candidate Name", key: "candidateName" },
                { label: "Job Role", key: "position" },
                { label: "Quantity(Hrs)", key: "actualWorkingHours" },
                { label: "Rate(₹)", key: "candidateRate" },
                { label: "Amount(₹)", key: "amount" }
              ];
        
            const val = [
                {
                    "candidateName": "Jithin U SS",
                    "position": "Software Engineer",
                    "submittedOn": "1665216279104",
                    "candidateRate": "60000",
                    "amount": 50000,
                    "actualWorkingHours": 64
                },
                {
                    "candidateName": "Jithin U SS",
                    "position": "Software Engineer",
                    "submittedOn": "1666021145718",
                    "candidateRate": "60000",
                    "amount": null,
                    "actualWorkingHours": 152
                }
            ]


    const navigate = useNavigate();
    useEffect(() => {

        const timesheet_id = timeSheetSelectedRow.map((timesheetData: any) => {
            if (timesheetData.status == 'Rejected' || timesheetData.status == 'Draft') {
                if (!error) {
                    setError(true);
                    displayNotification()
                }

            }
            return timesheetData.timesheetId;
        })
        let body: any = {
            timesheet_id: timesheet_id,
            year: "2022",
            month: "November",
            company_name: company_name,
        };
        fetchTimeSheetDetails(body);

    }, [timeSheetSelectedRow])

    const fetchTimeSheetDetails = (body: any) => {
        getListTimesheetDetails(body).then((response) => {
            if (response && response.status === 1) {
                setTimesheetData1(response.data)
                setTotal(response.totalAmount);
                setTimesheetCount(response.data)
            }
        });
    }
    const fetchTimeSheetDetails1 = (body: any) => {
        getListTimesheetDetails(body).then((response: any) => {

            if (response && response.status === 1) {

                fetch(response.url).then((response: any) => {
                    response.blob().then((blob: any) => {
                        const fileURL = window.URL.createObjectURL(blob);
                        let alink = document.createElement('a');
                        alink.href = fileURL;
                        alink.download = company_name + '-timesheet.pdf';
                        alink.click();
                    })
                })
            }
        });
    }
    const displayNotification = () => {
        setNotification(true)
        setTimeout(() => {
            setNotification(false)
        }, 3000)
    }
    const onClose = () => {
        setNotification(false)
    }
    const downloadfile = () => {
        const timesheet_id = timeSheetSelectedRow.map((timesheetData: any) => {
            if (timesheetData.status == 'Rejected' || timesheetData.status == 'Draft') {
                if (!error) {
                    setError(true);
                    displayNotification()
                }

            }
            return timesheetData.timesheetId;
        })
        let body: any = {
            timesheet_id: timesheet_id,
            year: "2022",
            month: "November",
            company_name: company_name
        };
        fetchTimeSheetDetails1(body);
    }
    return (
        <section className="dashboardWrapper">
            <SideMenu menu={menu} opentimesheet={'candidateTimesheets'} />
            <div className="dashboardContent">

                <section className="contentBox">
                    <div className={Styles.h100vh}>
                        <div className={Styles.dflex}>
                            <div>
                                <h2 className='company'>{company_name} <CSVLink data={timesheetCount} headers={headers}>
                                    <img src={file_download} />
                                </CSVLink></h2>
                                <p>{month} {year}</p>
                            </div>
                            <div>
                                <img src={ellowLogo} />
                            </div>
                        </div>
                        <Table type='candiatetimesheetdownload' data={timesheetData1} />
                        <div className={Styles.overall}>
                            <p className=''> Overall Amount:  <span className={Styles.total}>{total}</span></p>
                        </div>
                        {notification && <NotificationAlert onClose={onClose} closable={true} >This list contains non-approved timesheets  </NotificationAlert>}
                    </div>
                </section>
            </div>


        </section>
    )
}

export default CandidateTimesheetDownload